// Used Google Tag Manager to track events, google tag manager is configured in main.tsx
// The following events is being triggered because GTM is listening to the events here posted
// Once you have a new tracking event, you can add it here and then create the event in GTM (Custom event)
declare global {
  interface Window {
    uetq?: any[];
  }
}

import { IPlan } from "~/types/billing";
import { googleTagManagerKey } from "./environment";

export const triggerGTMEvent = (eventData: {
  event: string;
  event_category?: string;
  event_action?: string;
  event_label?: string;
  value?: string;
}) => {
  if (!googleTagManagerKey) {
    const { event, ...rest } = eventData;
    console.log(`[GTM Event - ${event}]`, rest);
    return;
  }

  // @ts-ignore
  if (window.dataLayer) {
    // @ts-ignore
    window.dataLayer.push(eventData);
  }
};

export function triggerBingAdsEvent(
  eventName: string,
  eventData: Record<string, any>
) {
  if (typeof window === "undefined") {
    return;
  }

  // @ts-ignore
  window.uetq = window.uetq || [];
  window.uetq.push("event", eventName, eventData);
}

export function triggerGtagPurchaseEvent(plan: IPlan) {
  const eventBasedOnPlanKey = {
    "starter-monthly": "purchaseStarter",
    "pro-monthly": "purchaseProMonthly",
    "pro-yearly": "purchaseProYearly",
    "empire-monthly": "purchaseEmpireMonthly",
    "empire-yearly": "purchaseEmpireYearly",
    "unicorn-monthly": "purchaseUnicornMonthly",
    "unicorn-yearly": "purchaseUnicornYearly",
  };
  const planKey = `${plan.name.toLowerCase()}-${plan.interval}`;
  const event =
    eventBasedOnPlanKey[planKey as keyof typeof eventBasedOnPlanKey];
  try {
    // @ts-ignore
    triggerGTMEvent({ event });
  } catch (err) {
    console.log(err);
  }
}

export function triggerStartedTrialEvent() {
  try {
    // @ts-ignore
    triggerGTMEvent({ event: "startedTrial" });
  } catch (err) {
    console.log(err);
  }
}

export function triggerCheckoutPageView() {
  try {
    // @ts-ignore
    triggerGTMEvent({ event: "checkoutPageView" });
  } catch (err) {
    console.log(err);
  }
}

export function triggerSignupEvent() {
  ``;
  try {
    // @ts-ignore

    triggerGTMEvent({ event: "userRegisterSuccess" });
  } catch (err) {
    console.log(err);
  }
}
